export const SETUP_IN_PROGRESS = 'SETUP_IN_PROGRESS';
export const SETUP_FAILED = 'SETUP_FAILED';
export const SETUP_SUCCESS = 'SETUP_SUCCESS';


// WEBPACK FOOTER //
// ./src/components/SetupLoader/setupLoaderActionType.js